/**
 * Local user adapter.
 * In local-only mode there is no authentication — we return a synthetic local user.
 * Auth is only required when S3 sync is enabled.
 */

export const LOCAL_USER_ID = "local-user";

export interface LocalUser {
  _id: string;
  name: string;
  email?: string;
  full_name?: string;
  approval_status: "approved";
  has_360crafter_cloud: false;
  has_byo_s3: boolean;
  subscription_type: "free";
  isLocal: true;
}

export function getLocalUser(): LocalUser {
  return {
    _id: LOCAL_USER_ID,
    name: "Local User",
    full_name: "Local User",
    approval_status: "approved",
    has_360crafter_cloud: false,
    has_byo_s3: false,
    subscription_type: "free",
    isLocal: true,
  };
}

export function useLocalUser(): LocalUser {
  return getLocalUser();
}

export function canCreateCraftspaceWithStorage(_storageProvider: "360crafter" | "custom-s3"): boolean {
  // In local mode, users can always use local storage.
  // BYO S3 is always allowed (credentials stored locally).
  return true;
}
